




























import { Component, Emit, Prop, Provide, Vue } from 'vue-property-decorator';
import GeofenceTabItem from './GeofenceTabItem.vue';
import { Method, OptionalCompanyID } from '../../../core/utils';
import PointsOfInterestTabItem from './PointsOfInterestTabItem.vue';
import { Geofence, IDescription, Point, PointsOfInterest } from '../../../core/models';
import { Mounted } from '../../../core/decorators';

@Component<GeofencesTab>({
    components: { PointsOfInterestTabItem, GeofenceTabItem }
})
export default class GeofencesTab extends Vue {
    active: number = 0;
    @Prop() @Provide() disableListenKey: Method<boolean, void>;
    @Prop() companySelected: OptionalCompanyID;

    @Mounted
    init(): void {
        this.isOpen();
    }

    @Emit()
    isOpen(): void {}

    @Emit()
    center(point: Point | Point[]): void {}

    @Emit()
    waitForEditPoint(point: PointsOfInterest): void {}

    @Emit()
    waitForAddPoint(): void {}

    @Emit()
    waitForAddGeoFence(): void {}

    @Emit()
    waitForEditGeoFence(geoFence: Geofence): void {}
}
